import React from 'react';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Link} from 'react-router-dom';
import {convertValueToDollar} from 'common/utils';
import {Icon, Button} from 'semantic-ui-react';
import _ from 'lodash';

export default class BulkTaskResults extends React.Component {
  render() {
    const {
      results,
      assignTask,
      unassignTask,
      userId,
      columns,
      handleCheckboxChange,
      masterChecked,
      handleMasterCheckbox,
      summary,
      disableFlagForFollowup,
    } = this.props;

    let headers = [
      <FemaGoTable.CheckboxCell
        key="headerCheckbox"
        isHeader
        label="Select All Grants"
        hideLabel={true}
        className="header-checkbox"
        collapsing={true}
        checked={masterChecked}
        handleChange={(label, value) => handleMasterCheckbox(value)}
      />,
    ];
    if (!disableFlagForFollowup) {
      headers.push(
        <FemaGoTable.HeaderCell
          key={'flaggedForFollowup'}
          arialabel="Flag For Followup"
        />
      );
    }
    headers = headers.concat(
      columns.map((column) => {
        return (
          <FemaGoTable.HeaderCell key={column.label}>
            {column.label}
          </FemaGoTable.HeaderCell>
        );
      })
    );

    const rows = results.map((result) => {
      let cells = [];
      if (!disableFlagForFollowup && result.followUpRequired === true) {
        cells.push(<FemaGoTable.TextCell key={result.id + 'emptyCell'} />);
        cells.push(
          <FemaGoTable.TextCell key={result.id + 'flaggedForFollowup'}>
            <Icon name="flag" title="Flagged for followup" />
          </FemaGoTable.TextCell>
        );
      } else if (
        (result.assignee && result.assignee !== userId) ||
        _.isEqual(_.get(result, 'userId'), userId) ||
        _.isEqual(_.get(result, 'excludedPerformer'), userId)
      ) {
        cells.push(<FemaGoTable.TextCell key={result.id + 'emptyCell'} />);
        if (!disableFlagForFollowup) {
          cells.push(<FemaGoTable.TextCell key={result.id + 'flaggedForFollowup'} />);
        }
      } else {
        const label = _.get(result, 'subGrantId', '')
          ? 'Subgrant with Id ' + result.subGrantId
          : 'Grant with Id ' + result.grantId;
        cells.push(
          <FemaGoTable.CheckboxCell
            key={result.id + 'checkboxCell'}
            label={label}
            hideLabel={true}
            collapsing={true}
            checked={result.checked}
            handleChange={(label, value) => handleCheckboxChange(result.id, value)}
          />
        );
        if (!disableFlagForFollowup) {
          cells.push(<FemaGoTable.TextCell key={result.id + 'flaggedForFollowup'} />);
        }
      }
      cells = cells.concat(
        columns.map((column, index) => {
          let cell;
          if (column.type === 'currency') {
            cell = (
              <FemaGoTable.TextCell key={result.id + index}>
                {convertValueToDollar(result[column.key])}
              </FemaGoTable.TextCell>
            );
          } else if (column.key === 'grantId' || column.key === 'subGrantId') {
            cell = (
              <FemaGoTable.TextCell key={result.id + index}>
                {column.key === 'grantId' ? (
                  <Link to={`/grant/${result[column.key]}`} target="_blank">
                    {result[column.key]}
                    <Icon name="external alternate" />
                  </Link>
                ) : (
                  <Link to={`/subgrant/${result[column.key]}`} target="_blank">
                    {result[column.key]}
                    <Icon name="external alternate" />
                  </Link>
                )}
              </FemaGoTable.TextCell>
            );
          } else if (column.key === 'assignee') {
            if (!result[column.key]) {
              cell = (
                <FemaGoTable.TextCell key={result.id + index}>
                  Unassigned <br />
                  <Button
                    title={'Start task for: ' + result.grantId + ' ' + result.name}
                    primary
                    onClick={() => assignTask(result.id)}
                  >
                    Start task{' '}
                  </Button>
                </FemaGoTable.TextCell>
              );
            } else if (result[column.key] === userId) {
              cell = (
                <FemaGoTable.TextCell key={result.id + index}>
                  {result[column.key]}{' '}
                  <a
                    className="table-link"
                    href="#"
                    title={'Unassign task ' + result.grantId}
                    onClick={() => unassignTask(result.id)}
                  >
                    (Unassign)
                    <br />
                  </a>
                  <Link label="continue task" to={`/tasks/${result.id}`}>
                    <Button
                      title={
                        'Continue working task for: ' + result.grantId + ' ' + result.name
                      }
                      primary
                    >
                      Continue working
                    </Button>
                  </Link>
                </FemaGoTable.TextCell>
              );
            } else {
              cell = (
                <FemaGoTable.TextCell key={result.id + index}>
                  {result[column.key]}
                </FemaGoTable.TextCell>
              );
            }
          } else {
            cell = (
              <FemaGoTable.TextCell key={result.id + index}>
                {result[column.key]}
              </FemaGoTable.TextCell>
            );
          }
          return cell;
        })
      );

      return <FemaGoTable.Row key={result.id}>{cells}</FemaGoTable.Row>;
    });

    return (
      <FemaGoTable type="static" summary={summary}>
        <FemaGoTable.Header>
          <FemaGoTable.Row>{headers}</FemaGoTable.Row>
        </FemaGoTable.Header>
        <FemaGoTable.Body>{rows}</FemaGoTable.Body>
      </FemaGoTable>
    );
  }
}
